const init = () => {
    const SLIDER_SELECTOR = '.gallery-slider__slider';
    const ARROWS_SELECTOR = '.gallery-slider__arrows';

    const $slider = $(SLIDER_SELECTOR);
    
    $slider.slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        rows: 0,
        appendArrows: ARROWS_SELECTOR,
        fade: true,
        adaptiveHeight: true,
    })

}

export default {
    init
}